import React from "react";

interface FormPopoverProps {
  show: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  align?: "left" | "right";
  children: React.ReactNode;
  submitLabel: string;
  submitLoadingLabel: string;
  submitColor: string;
  canSubmit: boolean;
  isLoading: boolean;
  onSubmit: () => void;
}

const FormPopover: React.FC<FormPopoverProps> = ({
  show,
  onClose,
  title,
  description,
  align = "left",
  children,
  submitLabel,
  submitLoadingLabel,
  submitColor,
  canSubmit,
  isLoading,
  onSubmit,
}) => {
  if (!show) return null;

  return (
    <div
      role="presentation"
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "absolute",
        top: "100%",
        [align]: 0,
        zIndex: 100,
      }}
    >
      <form
        onSubmit={(e) => e.preventDefault()}
        onKeyDown={(e) => {
          if (e.key === "Escape") onClose();
        }}
        style={{
          backgroundColor: "white",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          padding: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          minWidth: "240px",
        }}
      >
        <div style={{ fontSize: "13px", fontWeight: 600, marginBottom: "4px" }}>
          {title}
        </div>
        {description && (
          <div
            style={{
              fontSize: "11px",
              color: "#6b7280",
              marginBottom: "8px",
            }}
          >
            {description}
          </div>
        )}
        {children}
        <div
          style={{
            display: "flex",
            gap: "6px",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "4px 10px",
              fontSize: "12px",
              border: "1px solid #d1d5db",
              borderRadius: "4px",
              backgroundColor: "white",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={onSubmit}
            disabled={!canSubmit || isLoading}
            style={{
              padding: "4px 10px",
              fontSize: "12px",
              border: "none",
              borderRadius: "4px",
              backgroundColor: canSubmit ? submitColor : "#d1d5db",
              color: "white",
              cursor: canSubmit ? "pointer" : "not-allowed",
              fontWeight: 500,
            }}
          >
            {isLoading ? submitLoadingLabel : submitLabel}
          </button>
        </div>
      </form>
    </div>
  );
};

export default FormPopover;
